// extracted by mini-css-extract-plugin
module.exports = {"range":"ProgressBar_range__b9Qdx"};